<section class="page">
  <header class="page-header">
    <div>
      <h1>Users</h1>
      <p>Manage accounts and KYC review</p>
    </div>
  </header>

  @if (error()) {
    <div class="alert alert-error">{{ error() }}</div>
  }
  @if (success()) {
    <div class="alert alert-success">{{ success() }}</div>
  }

  <div class="panel">
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>KYC</th>
            <th>Kobble</th>
            <th>Login lock</th>
            <th>Status</th>
            <th>Created</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @if (loading()) {
            <tr>
              <td colspan="10" class="muted">Loading…</td>
            </tr>
          } @else if (!rows().length) {
            <tr>
              <td colspan="10" class="muted">No users found</td>
            </tr>
          } @else {
            @for (user of rows(); track user.id) {
              <tr class="clickable" (click)="open(user)">
                <td>{{ user.id }}</td>
                <td>{{ fullName(user) }}</td>
                <td>{{ user.email || '—' }}</td>
                <td>{{ user.phone || '—' }}</td>
                <td>
                  <span class="badge" [attr.data-status]="user.kyc_status">{{
                    user.kyc_status || '—'
                  }}</span>
                </td>
                <td>{{ user.kobble_status || '—' }}</td>
                <td>
                  @if (user.is_permanently_locked) {
                    <span class="badge" data-status="rejected">Blocked</span>
                  } @else if (user.is_temporarily_locked) {
                    <span class="badge" data-status="pending">Temp lock</span>
                  } @else {
                    <span class="muted">{{ lockLabel(user) }}</span>
                  }
                </td>
                <td>{{ user.status }}</td>
                <td>{{ user.created_at ? (user.created_at | date: 'mediumDate') : '—' }}</td>
                <td>
                  @if (isLoginLocked(user)) {
                    <button
                      class="btn btn-secondary"
                      type="button"
                      (click)="unblock(user, $event)"
                      [disabled]="unlockingId() === user.id"
                    >
                      {{ unlockingId() === user.id ? 'Unblocking…' : 'Unblock' }}
                    </button>
                  }
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <div class="pager">
      <span class="muted">Page {{ page() }} of {{ totalPages() }} · {{ total() }} total</span>
      <div class="pager-actions">
        <button class="btn btn-secondary" type="button" (click)="prev()" [disabled]="page() <= 1 || loading()">
          Previous
        </button>
        <button
          class="btn btn-secondary"
          type="button"
          (click)="next()"
          [disabled]="page() >= totalPages() || loading()"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</section>
